/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Weighings_Metric_FreshInputs */

const vi_my_weighings_metric_fresh = /** @type {(inputs: My_Weighings_Metric_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khối lượng chè tươi`)
};

/**

* @param {My_Weighings_Metric_FreshInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_weighings_metric_fresh = /** @type {((inputs?: My_Weighings_Metric_FreshInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Weighings_Metric_FreshInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_weighings_metric_fresh(inputs)
});